var LOCAL_STORAGE_PREFIX = "poker-backoffice";
export var LocalStorageKeys = {
    TENANT: "".concat(LOCAL_STORAGE_PREFIX, ".tenant"),
    SIDEBAR_COLLAPSED: "".concat(LOCAL_STORAGE_PREFIX, ".sidebar.collapsed"),
    USER_DATA: "".concat(LOCAL_STORAGE_PREFIX, ".user_data"),
};
